"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ZONE_PROFILE_SETTING = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/taggedTemplateLiteral.js"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _templateObject;
var UPDATE_ZONE_PROFILE_SETTING = exports.UPDATE_ZONE_PROFILE_SETTING = (0, _graphqlTag.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\nmutation updateZoneProfileSetting($zoneID: String!, $changes: zone_profile_setting_set_input!) {\n  update_zone_profile_setting_by_pk(\n    pk_columns: { zone_id: $zoneID }\n    _set: $changes\n  ) {\n    zone_id\n  }\n}\n"])));